/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React from 'react';
import useFormApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-form-api';
import { FooterButtons } from './FooterButtons';
import { useDdf } from '../../context/ddf-context';
import FormSpy from '@data-driven-forms/react-form-renderer/dist/cjs/form-spy';
import { FormTemplateRenderProps } from '@data-driven-forms/react-form-renderer';
import Schema from '@data-driven-forms/react-form-renderer/dist/cjs/schema';
import clsx from 'clsx';
import { Transition } from '@headlessui/react';
import { PageSpinner } from '@td-client-frontend/common';

interface FormButton {
  name: string;
  title: string;
  type?: HTMLButtonElement['type'];
  kind: string;
  action: string;
  hiddenForTypes?: string[];
}

interface ExtendedSchema extends Schema {
  buttons: {
    colWidth?: number;
    left?: FormButton[];
    right?: FormButton[];
    readOnly?: {
      left?: FormButton[];
      right?: FormButton[];
    };
  };
}

interface ExtendedFormTemplateProps extends FormTemplateRenderProps {
  schema: ExtendedSchema;
}

const filterBtnFn =
  (type = '') =>
  (button) => {
    if (!button.hiddenForTypes?.length || !type) {
      return true;
    }
    const hiddenForTypes = button.hiddenForTypes.map((type) => type?.toLowerCase());
    return !hiddenForTypes.includes(type!.toLowerCase());
  };

const getModalFooterStyle = (noFooterButtons?: boolean) => {
  return { height: noFooterButtons ? 'calc(100% - 2.5rem)' : 'calc(100% - 5.5rem)' };
};

export default function FormTemplate({ formFields, schema: { buttons, fields } }: ExtendedFormTemplateProps) {
  const { handleSubmit } = useFormApi();
  const { isInModal, readOnly, groupType, loading, noFooterBtns } = useDdf();
  const buttonsToDisplay = {
    right: buttons?.right?.filter(filterBtnFn(groupType)) ?? [],
    left: buttons?.left?.filter(filterBtnFn(groupType)) ?? []
  };

  return (
    <form noValidate onSubmit={handleSubmit} className="relative flex flex-wrap w-full h-full max-h-full">
      <div
        className={clsx('w-full h-full z-1', isInModal && 'relative overflow-x-auto')}
        style={isInModal ? getModalFooterStyle(noFooterBtns) : {}}
      >
        {formFields}
      </div>
      <FormSpy>
        {({ hasValidationErrors }) => (
          <>
            {!noFooterBtns && (
              <FooterButtons
                hasValidationErrors={hasValidationErrors}
                buttons={readOnly ? buttons.readOnly : buttonsToDisplay}
                isInModal={isInModal}
                className={isInModal ? 'absolute bottom-0 bg-gray-10 border-t-1 border-gray-20' : ''}
              />
            )}
          </>
        )}
      </FormSpy>
      <Transition
        show={loading}
        enter="ease-out duration-150"
        enterFrom="opacity-25"
        enterTo="opacity-100"
        leave="ease-in duration-100"
        leaveFrom="opacity-100"
        leaveTo="opacity-25"
      >
        <div className="absolute inset-0 flex items-center justify-center w-full bg-white opacity-75">
          <PageSpinner />
        </div>
      </Transition>
    </form>
  );
}
